import { StyleSheet } from "react-native";
import { theme } from "../../theme";
const baseStyles = {
    paddingHorizontal: theme.spacing.large,
    paddingVertical: theme.spacing.medium,
};
export const styles = StyleSheet.create({
    wrapper: {
        ...baseStyles,
        flexDirection: "row",
        justifyContent: "space-between",
        maxWidth: 400,
    },
    content: {
        display: "flex",
        flexDirection: "row",
    },
    heading: {
        fontWeight: "bold",
        color: theme.colors.light.base,
    },
    subheading: {
        fontWeight: "600",
        marginVertical: 10,
    },
    strapline: {
        fontWeight: "bold",
        color: theme.colors.light.base,
    },
    image: {
        alignItems: "center",
        justifyContent: "center",
    },
    button: {
        marginTop: 25,
    },
    children: {},
});
//# sourceMappingURL=BigLinkCard.styles.js.map